import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { ISku } from "@/interfaces/sku.interface";
import skuService from "@/services/sku.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetSkuByIdReturn = RequestsBaseReturn<ISku | null>;

export type UseGetSkuByIdProps = ByIdRequestProps & {
  enabled?: boolean;
};

type UseSwrGetSkuByIdParams = [string, number] | null;

const useGetSkuById = ({ _id, enabled = true }: UseGetSkuByIdProps): UseGetSkuByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<ISku, Error, UseSwrGetSkuByIdParams>(
    enabled && _id ? [SWR_KEYS.getSkuById, _id] : null,
    ([, skuId]) => skuService.getById(skuId),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetSkuById;
